export default __webpack_public_path__ + "static/media/soluciones__4.91516693.jpg";